<!-- Footer opened -->
<div class="main-footer">
    <div class="col-md-12 col-sm-12 text-center">
    <div class="container-fluid pt-0 ht-100p">
         Copyright © 2023 <a href="javascript:void(0);" class="text-primary">nowa</a>. Designed with <span class="fa fa-heart text-danger"></span> by <a href="javascript:void(0);"> Spruko </a> All rights reserved
    </div>
</div>
</div>
<!-- Footer closed -->
